module.exports = __webpack_public_path__ + "img/three_1.5fc918d4.png";